export default __webpack_public_path__ + "static/B0291-e21ba1f6a01afb3db27fb2dbc43e9d59.png";